import React, { useState, useEffect } from 'react'
import Loadable from 'react-loadable'
import { Route, Router as BrowserRouter, Switch } from 'react-router-dom'
import { AutomationCreateContainer, AutomationDetailContainer, AutomationListSearchContainer } from '../app/Automation/automation'
import { caseFieldCreateContainer, caseFieldDetailContainer, caseFieldListSearchContainer } from '../app/caseField/caseField'
import { HierarchyContainer } from '../app/category-hierarchy/hierarchy'
// Custom Imports
import { PrivateRoute, PrivateRouteCustom } from '../app/common'
import { AuditLogDetailContainer, AuditLogListSearchContainer } from '../app/common/auditLog/auditLog'
import { AuditConfigCreateContainer, AuditConfigDetailContainer, AuditConfigListSearchContainer } from '../app/common/base/entities/auditConfig/auditConfig'
// import { SettingsDetailContainer, SettingsListSearchContainer } from '../app/common/base/entities/settings/settings';
import { CustomerSurveyDetailContainer, CustomerSurveyListSearchContainer } from '../app/common/customerSurvey/customerSurvey'
import { EmailSignatureDetailContainer, EmailSignatureListSearchContainer } from '../app/common/emailSignature/emailSignature'
import { EmailTemplateCreateContainer, EmailTemplateDetailContainer, EmailTemplateListSearchContainer } from '../app/common/emailTemplates/emailTemplates'
import { reloadResources } from '../app/common/infra/i18n'
// import { SettingDetailContainer, SettingListSearchContainer } from '../app/common/setting/setting';
import { TicketingDashboardContainer } from '../app/dashboard/TicketDashboardNew'
import { emailSettingDetailContainer, emailSettingListSearchContainer } from '../app/emailSettings/emailSettings'
import { jobDetailContainer, jobListSearchContainer } from '../app/Job/job'
import { MailServerCreateContainer, MailServerDetailContainer, MailServerListSearchContainer } from '../app/mailServer/mailServer'
import { ProcessFlowListSearchContainer } from '../app/processFlow/processFlow'
import { queueCreateContainer, queueDetailContainer, queueListSearchContainer } from '../app/Queue/queue'
import  ApprovalTicketByEmail  from '../app/emailApproval/containers/EmailApproval'

import { slaMetricsResponseCreateContainer, slaMetricsResponseDetailContainer, slaMetricsResponseListSearchContainer } from '../app/responseSla/responseSla'
import { slaMetricsCreateContainer, slaMetricsDetailContainer, slaMetricsListSearchContainer } from '../app/slaMetrics/slaMetrics'
import { OverriddenStateListSearchContainer, statusConfigurationCreateContainer } from '../app/statusConfiguration/statusConfiguration'
import { CategoryContainer } from '../app/ticketCategory/category'
import { UserQueueCreateContainer, UserQueueDetailContainer, UserQueueListSearchContainer } from '../app/userQueue/userQueue'
import { history } from './history'
import { HiOutlineUserGroup,HiOutlineTicket,HiOutlineWrench } from "react-icons/hi2"
import { TfiComments } from "react-icons/tfi"
import { BsSliders } from "react-icons/bs"
import { MdOutlineSupportAgent } from "react-icons/md"
import {FaUserPlus} from "react-icons/fa"
import {
    RiDashboard2Fill,
	RiListSettingsFill,
} from 'react-icons/ri'
import { ImTicket } from "react-icons/im"
function Loading() {
	return <div className="loader"></div>
}

const caseFieldList = Loadable({
	loader: () => caseFieldListSearchContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})
const caseFieldDetail = Loadable({
	loader: () => caseFieldDetailContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})

const caseFieldCreate = Loadable({
	loader: () => caseFieldCreateContainer,
	loading: Loading,
})

const hierarchyContainer = Loadable({
	loader: () => HierarchyContainer,
	loading: Loading,
})

const categoryContainer = Loadable({
	loader: () => CategoryContainer,
	loading: Loading,
})

// const SettingsList = Loadable({
//     loader: () =>  SettingsListSearchContainer,
//         // let comp = import('../app/common/base/entities/settings/settings')
//     loading: Loading
// })
// const SettingsDetail = Loadable({
//     loader: () =>  SettingsDetailContainer,
//         // let comp = import('../app/common/base/entities/settings/settings')
//     loading: Loading
// })

// const SettingList = Loadable({
//     loader: () =>  SettingListSearchContainer,
//         // let comp = import('../app/common/base/entities/settings/settings')
//     loading: Loading
// })
// const SettingDetail = Loadable({
//     loader: () =>  SettingDetailContainer,
//         // let comp = import('../app/common/base/entities/settings/settings')
//     loading: Loading
// })

const AuditLogList = Loadable({
	loader: () => AuditLogListSearchContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})

const AuditLogDetail = Loadable({
	loader: () => AuditLogDetailContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})

const Home = Loadable({
	loader: () => import('../app/common/containers/Home'),
	loading: Loading,
})
const ErrorPage = Loadable({
	loader: () => import('../app/common/containers/ErrorPage'),
	loading: Loading,
})
const Logout = Loadable({
	loader: () => import('../app/common/containers/Logout'),
	loading: Loading,
})
const UserQueueList = Loadable({
	loader: () => UserQueueListSearchContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})
const UserQueueDetail = Loadable({
	loader: () => UserQueueDetailContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})

const UserQueueCreate = Loadable({
	loader: () => UserQueueCreateContainer,
	loading: Loading,
})

const queueList = Loadable({
	loader: () => queueListSearchContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})
const queueDetail = Loadable({
	loader: () => queueDetailContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})

const queueCreate = Loadable({
	loader: () => queueCreateContainer,
	loading: Loading,
})

const approveByEmail = Loadable({
	loader: () => import('../app/emailApproval/containers/EmailApproval'),
	loading: Loading,
})

const jobList = Loadable({
	loader: () => jobListSearchContainer,
	loading: Loading,
})
const jobDetail = Loadable({
	loader: () => jobDetailContainer,
	loading: Loading,
})

const MailServerList = Loadable({
	loader: () => MailServerListSearchContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})
const MailServerCreate = Loadable({
	loader: () => MailServerCreateContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})

const MailServerDetail = Loadable({
	loader: () => MailServerDetailContainer,
	loading: Loading,
})

const AutomationList = Loadable({
	loader: () => AutomationListSearchContainer,
	// let comp = import('../app/common/base/entities/settings/settings')
	loading: Loading,
})

const AutomationDetail = Loadable({
	loader: () => AutomationDetailContainer,
	loading: Loading,
})

const AutomationCreate = Loadable({
	loader: () => AutomationCreateContainer,
	loading: Loading,
})

const TicketListing = Loadable({
	loader: () => import('../app/ticket-management/containers/TicketListingContainer'),
	loading: Loading,
})
const AllTicketListing = Loadable({
	loader: () => import('../app/ticket-management/containers/AllTicketListingContainer'),
	loading: Loading,
})
const SupportTicketListing = Loadable({
	loader: () => import('../app/common/ticketing/containers/SupportTicketListingContainer'),
	loading: Loading,
})

const CreateTicket = Loadable({
	loader: () => import('../app/common/ticketing/containers/CreateTicketContainer'),

	loading: Loading,
})

const SupportTicket = Loadable({
	loader: () => import('../app/common/ticketing/containers/CreateSupportTicketContainer'),
	loading: Loading,
})

const DetailTicket = Loadable({
	loader: () => import('../app/common/ticketing/containers/DetailTicketContainer'),
	loading: Loading,
})

const PrintTicket = Loadable({
	loader: () => import('../app/common/ticketing/containers/PrintTicketContainer'),
	loading: Loading,
})

const DetailSupportTicket = Loadable({
	loader: () => import('../app/common/ticketing/containers/DetailSupportTicketContainer'),
	loading: Loading,
})

const ProfileContainer = Loadable({
	loader: () => import('../app/common/containers/ProfileContainer'),
	loading: Loading,
})
const TicketingDashboard = Loadable({
	loader: () => TicketingDashboardContainer,
	loading: Loading,
})

const AuditConfigList = Loadable({
	loader: () => AuditConfigListSearchContainer,
	loading: Loading,
})
const AuditConfigDetail = Loadable({
	loader: () => AuditConfigDetailContainer,
	loading: Loading,
})
const AuditConfigCreate = Loadable({
	loader: () => AuditConfigCreateContainer,
	loading: Loading,
})

const Reports = Loadable({
	loader: () => import('../app/reports/containers/ReportsContainer'),
	loading: Loading,
})

const emailTemplatesList = Loadable({
	loader: () => EmailTemplateListSearchContainer,
	loading: Loading,
})
const emailTemplatesDetail = Loadable({
	loader: () => EmailTemplateDetailContainer,
	loading: Loading,
})

const emailTemplatesCreate = Loadable({
	loader: () => EmailTemplateCreateContainer,
	loading: Loading,
})

const emailSignatureList = Loadable({
	loader: () => EmailSignatureListSearchContainer,
	loading: Loading,
})
const emailSignatureDetail = Loadable({
	loader: () => EmailSignatureDetailContainer,
	loading: Loading,
})
const customerSurveyList = Loadable({
	loader: () => CustomerSurveyListSearchContainer,
	loading: Loading,
})
const customerSurveyDetail = Loadable({
	loader: () => CustomerSurveyDetailContainer,
	loading: Loading,
})

const SlaListComponent = Loadable({
	loader: () => slaMetricsListSearchContainer,
	loading: Loading,
})
const SlaCreateComponent = Loadable({
	loader: () => slaMetricsCreateContainer,
	loading: Loading,
})
const SlaDetailComponent = Loadable({
	loader: () => slaMetricsDetailContainer,
	loading: Loading,
})

const ResponseSlaListComponent = Loadable({
	loader: () => slaMetricsResponseListSearchContainer,
	loading: Loading,
})

const ResponseSlaCreateComponent = Loadable({
	loader: () => slaMetricsResponseCreateContainer,
	loading: Loading,
})

const ResponseSlaDetailComponent = Loadable({
	loader: () => slaMetricsResponseDetailContainer,
	loading: Loading,
})

const StatusConfigurationCreateComponent = Loadable({
	loader: () => statusConfigurationCreateContainer,
	loading: Loading,
})

const OverriddenStateListSearchComponent = Loadable({
	loader: () => OverriddenStateListSearchContainer,
	loading: Loading,
})

const ProcessFlowListSearchComponent = Loadable({
	loader: () => ProcessFlowListSearchContainer,
	loading: Loading,
})

const emailSettingList = Loadable({
	loader: () => emailSettingListSearchContainer,
	loading: Loading,
})
const emailSettingsDetail = Loadable({
	loader: () => emailSettingDetailContainer,
	loading: Loading,
})
export const routeList = [
	// Open Routes
	{ path: '/login', exact: true, component: Home, isNav: false },
	{ path: '/logout', exact: true, component: Logout, isNav: false },
	{ path: '/home', exact: true, component: Home, isNav: false },
	{
		path: '/botmanagement',
		exact: true,
		app: { path: 'botmanagement' },
		isNav: true,
		icon: <HiOutlineUserGroup/>,
		name: 'virtualAgentMgmt',
		label: 'Virtual Agent Mgmt',
		allowedRole: ['bot_analyst', 'bot_admin'],
	},
	{
		path: '/catalog',
		exact: true,
		app: { path: 'catalog' },
		isNav: true,
		name: 'catalog',
		label: 'Service Catalog',
		icon: <HiOutlineWrench/>,
		allowedRole: ['asc_admin'],
	},
	//ticketing menus
	// {
	// 	path: '/approvals',
	// 	exact: true,
	// 	component: TicketListing,
	// 	isNav: true,
	// 	name: 'tickets',
	// 	label: 'Requests Management',
	// 	icon: 'fa fa-ticket',
	// 	allowedRole: ['approver', 'requestor'],
	// 	children: [
	// 		{
	// 			path: '/approvals/my-requests',
	// 			exact: true,
	// 			icon: 'fa fa-ticket',
	// 			component: TicketListing,
	// 			isNav: true,
	// 			name: 'ticketList',
	// 			label: 'My Requests',
	// 			allowedRole: ['requestor'],
	// 			// icon: 'fa fa-ticket',
	// 		},
	// 		{
	// 			path: '/approvals/my-approvals',
	// 			exact: true,
	// 			icon: 'fa fa-ticket',
	// 			component: TicketListing,
	// 			isNav: true,
	// 			name: 'ticketList',
	// 			label: 'For My Approvals',
	// 			allowedRole: ['approver'],
	// 			// icon: 'fa fa-ticket',
	// 		},
	// 		{
	// 			path: '/approvals/reports',
	// 			exact: true,
	// 			icon: 'icon-graph',
	// 			component: Reports,
	// 			isNav: true,
	// 			name: 'report',
	// 			label: 'Reports',
	// 			allowedRole: ['approver', 'approval_admin'],
	// 		},
	// 		{
	// 			path: '/approvals/requests/createRequest',
	// 			exact: true,
	// 			component: CreateTicket,
	// 			isNav: false,
	// 			name: 'createTicket',
	// 			label: 'Create Ticket',
	// 			icon: 'fa fa-support',
	// 			allowedRole: ['approver', 'requestor'],
	// 		},
	// 		{
	// 			path: '/approvals/requests/request-detail/:caseRefId',
	// 			exact: true,
	// 			component: DetailTicket,
	// 			isNav: false,
	// 			name: 'ticketDetail',
	// 			label: 'Ticket Detail',
	// 			icon: 'fa fa-support',
	// 			allowedRole: ['requestor'],
	// 		},
	// 		{
	// 			path: '/approvals/requests/ticket-print/:caseRefId',
	// 			exact: true,
	// 			component: PrintTicket,
	// 			isNav: false,
	// 			name: 'ticketPrintDetail',
	// 			label: 'Ticket Print Detail',
	// 			icon: 'fa fa-support',
	// 			allowedRole: ['requestor'],
	// 		},
	// 		{
	// 			path: '/approvals/approvals/approval-detail/:caseRefId',
	// 			exact: true,
	// 			component: DetailTicket,
	// 			isNav: false,
	// 			name: 'ticketDetail',
	// 			label: 'Ticket Detail',
	// 			icon: 'fa fa-support',
	// 			allowedRole: ['approver'],
	// 		},
	// 		{
	// 			path: '/approvals/approvals/ticket-print/:caseRefId',
	// 			exact: true,
	// 			component: PrintTicket,
	// 			isNav: false,
	// 			name: 'ticketPrintDetail',
	// 			label: 'Ticket Print Detail',
	// 			icon: 'fa fa-support',
	// 			allowedRole: ['approver'],
	// 		},
	// 		{
	// 			path: '/approvals/job',
	// 			icon: 'fa fa-user-plus',
	// 			exact: true,
	// 			component: jobList,
	// 			isNav: true,
	// 			allowedRole: ['approver', 'approval_admin'],
	// 			name: 'job',
	// 			label: 'Job',
	// 		},
	// 		{
	// 			path: '/approvals/job/update/:itemId',
	// 			exact: true,
	// 			component: jobDetail,
	// 			isNav: false,
	// 			allowedRole: ['approver', 'approval_admin'],
	// 			name: 'jobDetail',
	// 			label: 'Job Detail',
	// 		},
	// 		{
	// 			path: '/approvals/UserQueue',
	// 			icon: 'fa fa-users',
	// 			exact: true,
	// 			component: /* subdomain ? lPage :*/ UserQueueList,
	// 			isNav: true,
	// 			allowedRole: ['approval_admin'],
	// 			name: 'userQueue',
	// 			label: 'User Queue',
	// 		},
	// 		{
	// 			path: '/approvals/UserQueue/update/:itemId',
	// 			exact: true,
	// 			component: /* subdomain ? lPage :*/ UserQueueDetail,
	// 			isNav: false,
	// 			allowedRole: ['approval_admin'],
	// 			name: 'userQueueDetail',
	// 			label: 'User Queue Detail',
	// 		},
	// 		{ path: '/approvals/UserQueue/create', exact: true, component: UserQueueCreate, isNav: false, allowedRole: ['approval_admin'], name: 'UserQueueCreate' },
	// 		{
	// 			path: '/approvals/queue',
	// 			icon: 'fa fa-user-plus',
	// 			exact: true,
	// 			component: /* subdomain ? lPage :*/ queueList,
	// 			isNav: true,
	// 			allowedRole: ['approval_admin'],
	// 			name: 'queue',
	// 			label: 'Queue',
	// 		},
	// 		{
	// 			path: '/approvals/queue/update/:itemId',
	// 			exact: true,
	// 			component: /* subdomain ? lPage :*/ queueDetail,
	// 			isNav: false,
	// 			allowedRole: ['approval_admin'],
	// 			name: 'queueDetail',
	// 			label: 'Queue Detail',
	// 		},
	// 		{ path: '/approvals/queue/create', exact: true, component: queueCreate, isNav: false, allowedRole: ['approval_admin'], name: 'queueCreate' },
	// 		{ path: '/approvals/Approved/:caseRefId', exact: false, component: approveByEmail, isNav: false, allowedRole: ['approver', 'approval_admin','requestor'] },
	// 		{ path: '/approvals/Rejected/:caseRefId', exact: false, component: approveByEmail, isNav: false, allowedRole: ['approver', 'approval_admin','requestor'] },
	// 		{ path: '/approvals/Approved-Level1/:caseRefId', exact: false, component: approveByEmail, isNav: false, allowedRole: ['approver', 'approval_admin','requestor'] },
	// 	],
	// },
	{
		path: '/tickets',
		exact: true,
		component: TicketListing,
		isNav: true,
		name: 'tickets',
		label: 'Ticket Management',
		icon: <HiOutlineTicket/>,
		allowedRole: ['ticket_user', 'ticket_agent', 'ticket_agent_supervisor', 'ticket_admin'],
		newAppRoute:{path:"agent/inbox", allowedRoles:['ticket_agent', 'ticket_agent_supervisor','ticket_admin', 'ticket_user']},
		children: [
			{
				path: '/tickets/dashboard',
				exact: true,
				component: TicketingDashboard,
				isNav: true,
				name: 'dashboard',
				label: 'Dashboard',
				icon: <RiDashboard2Fill/>,
				allowedRole: ['ticket_agent_supervisor'],
			},
			{
				path: '/tickets/my-tickets',
				exact: true,
				icon: <ImTicket/>,
				component: TicketListing,
				isNav: true,
				name: 'ticketList',
				label: 'My Tickets',
				allowedRole: ['ticket_user', 'ticket_agent', 'ticket_agent_supervisor', 'helpdesk_agent','customer_agent'],
				newAppRoute:"agent/inbox"
				// icon: 'fa fa-ticket',
			},
			{
				path: '/tickets/all-tickets',
				exact: true,
				icon: <ImTicket/>,
				component: AllTicketListing,
				isNav: true,
				name: 'allTicketList',
				label: 'All Tickets',
				allowedRole: [],
				moduleName: 'allTickets',
				// icon: 'fa fa-ticket',
				routeProps: { isAdavanceSearch: true },
			},
			{
				path: '/tickets/createTicket',
				exact: true,
				component: CreateTicket,
				isNav: false,
				name: 'createTicket',
				label: 'Create Ticket',
				icon: 'fa fa-support',
				allowedRole: ['ticket_user', 'ticket_agent', 'ticket_agent_supervisor', 'ticket_admin', 'helpdesk_agent','customer_agent'],
			},
			{
				path: '/tickets/ticket-detail/:caseRefId',
				exact: true,
				component: DetailTicket,
				isNav: false,
				name: 'ticketDetail',
				label: 'Ticket Detail',
				icon: 'fa fa-support',
				allowedRole: ['ticket_user', 'ticket_agent', 'ticket_agent_supervisor', 'ticket_admin', 'helpdesk_agent','customer_agent'],
			},
			{
				path: '/tickets/ticket-print/:caseRefId',
				exact: true,
				component: PrintTicket,
				isNav: false,
				name: 'ticketPrintDetail',
				label: 'Ticket Print Detail',
				icon: 'fa fa-support',
				allowedRole: ['ticket_agent_supervisor', 'ticket_admin','ticket_agent'],
			},
			{
				path: '/tickets/UserQueue',
				icon: 'fa fa-users',
				exact: true,
				component: /* subdomain ? lPage :*/ UserQueueList,
				isNav: true,
				allowedRole: ['ticket_admin', 'ticket_agent_supervisor'],
				name: 'userQueue',
				label: 'User Queue',
			},
			{
				path: '/tickets/UserQueue/update/:itemId',
				exact: true,
				component: /* subdomain ? lPage :*/ UserQueueDetail,
				isNav: false,
				allowedRole: ['ticket_admin', 'ticket_agent_supervisor'],
				name: 'userQueueDetail',
				label: 'User Queue Detail',
			},
			{
				path: '/tickets/UserQueue/create',
				exact: true,
				component: UserQueueCreate,
				isNav: false,
				allowedRole: ['ticket_admin', 'ticket_agent_supervisor'],
				name: 'UserQueueCreate',
			},
			{
				path: '/tickets/queue',
				icon: <FaUserPlus/>,
				exact: true,
				component: /* subdomain ? lPage :*/ queueList,
				isNav: true,
				allowedRole: ['ticket_admin'],
				name: 'queue',
				label: 'Queue',
			},
			{
				path: '/tickets/queue/update/:itemId',
				exact: true,
				component: /* subdomain ? lPage :*/ queueDetail,
				isNav: false,
				allowedRole: ['ticket_admin'],
				name: 'queueDetail',
				label: 'Queue Detail',
			},
			{ path: '/tickets/queue/create', exact: true, component: queueCreate, isNav: false, allowedRole: ['ticket_admin'], name: 'queueCreate' },
			{
				path: '/tickets/job',
				icon: 'fa fa-random',
				exact: true,
				component: jobList,
				isNav: true,
				allowedRole: ['ticket_admin', 'ticket_agent_supervisor','customer_agent'],
				name: 'job',
				label: 'Request',
			},
			{
				path: '/tickets/job/update/:itemId',
				exact: true,
				component: jobDetail,
				isNav: false,
				allowedRole: ['ticket_agent_supervisor','customer_agent'],
				name: 'jobDetail',
				label: 'Request Detail',
			},
			{
				path: '/tickets/reports',
				exact: true,
				component: Reports,
				isNav: true,
				name: 'report',
				label: 'Reports',
				icon: 'icon-graph',
				allowedRole: ['ticket_admin', 'ticket_agent_supervisor','customer_agent'],
			},
			{
				path: '/tickets/AuditConfig/create',
				exact: true,
				component: /* subdomain ? lPage :*/ AuditConfigCreate,
				isNav: false,
				allowedRole: ['ASC Admin'],
				name: 'AuditConfigCreate',
			},
			{
				path: '/tickets/AuditConfig',
				icon: 'fa fa-file-text',
				exact: true,
				component: /* subdomain ? lPage :*/ AuditConfigList,
				isNav: true,
				allowedRole: ['ASC Admin'],
				name: 'auditConfig',
				label: 'Audit Config',
			},
			{
				path: '/tickets/AuditConfig/update/:itemId',
				exact: true,
				component: /* subdomain ? lPage :*/ AuditConfigDetail,
				isNav: false,
				allowedRole: ['ASC Admin'],
				name: 'auditConfigDetail',
				label: 'Audit Config Detail',
			},
			{
				path: '/tickets/',
				icon: <RiListSettingsFill/>,
				exact: true,
				component: /* subdomain ? lPage :*/ TicketListing,
				isNav: true,
				className:'ticket-settings',
				allowedRole: ['ASC Admin', 'ticket_admin'],
				name: 'settings',
				label: 'Settings',
				children: [
					{
						path: '/tickets/categoryHierarchy',
						exact: true,
						component: hierarchyContainer,
						isNav: true,
						name: 'categoryHierarchy',
						label: 'Category Hierarchy',
						icon: 'fa fa-users',
						allowedRole: [],
					},
					{
						path: '/tickets/TicketCategory',
						exact: true,
						component: categoryContainer,
						isNav: true,
						name: 'category',
						label: 'Category',
						icon: 'fa fa-users',
						allowedRole: ['ASC Admin', 'ticket_admin'],
					},

					{
						path: '/tickets/CaseField',
						icon: 'fa fa-user-plus',
						exact: true,
						component: /* subdomain ? lPage :*/ caseFieldList,
						isNav: true,
						allowedRole: ['ASC Admin'],
						name: 'CaseField',
						label: 'Case Field',
					},
					{
						path: '/tickets/CaseField/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ caseFieldDetail,
						isNav: false,
						allowedRole: ['ASC Admin'],
						name: 'CaseFieldDetail',
						label: 'CaseField Detail',
					},
					{
						path: '/tickets/CaseField/create',
						exact: true,
						component: caseFieldCreate,
						isNav: false,
						allowedRole: ['ASC Admin'],
						name: 'CaseFieldCreate',
						label: 'CaseField Create',
					},

					// {path: '/tickets/Setting',icon: 'fa fa-cog', exact: true, component: /* subdomain ? lPage :*/ SettingList, isNav: true, allowedRole: ["ASC Admin"], name:'setting', label: 'Setting'},

					// {path: '/tickets/Setting/update/:itemId', exact: true, component: /* subdomain ? lPage :*/ SettingDetail, isNav: false, allowedRole: ['ASC Admin'], name:'settingsDetail', label: 'Audit Config Detail' },
					{
						path: '/tickets/MailServer',
						icon: 'fa fa-user-plus',
						exact: true,
						component: /* subdomain ? lPage :*/ MailServerList,
						isNav: true,
						allowedRole: ['ASC Admin'],
						name: 'mailServer',
						label: 'Mail Server',
					},
					{
						path: '/tickets/MailServer/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ MailServerDetail,
						isNav: false,
						allowedRole: ['ASC Admin'],
						name: 'mailServerDetail',
						label: 'Mail Server Detail',
					},
					{
						path: '/tickets/automation',
						icon: 'fa fa-user-plus',
						exact: true,
						component: /* subdomain ? lPage :*/ AutomationList,
						isNav: true,
						allowedRole: ['ticket_admin'],
						name: 'automation',
						label: 'Automation',
					},
					{
						path: '/tickets/automation/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ AutomationDetail,
						isNav: false,
						allowedRole: ['ticket_admin'],
						name: 'automationDetail',
						label: 'Automation Detail',
					},
					{
						path: '/tickets/automation/create',
						exact: true,
						component: /* subdomain ? lPage :*/ AutomationCreate,
						isNav: false,
						allowedRole: ['ticket_admin'],
						name: 'AutomationCreate',
						label: 'Automation Create',
					},
					{ path: '/tickets/MailServer/create', exact: true, component: MailServerCreate, isNav: false, allowedRole: ['ASC Admin'], name: 'Mail ServerCreate' },
					{
						path: '/tickets/EmailTemplates',
						icon: 'fa fa-user-plus',
						exact: true,
						component: /* subdomain ? lPage :*/ emailTemplatesList,
						isNav: true,
						allowedRole: [],
						name: 'emailTemplates',
						label: 'Email Templates',
					},
					{
						path: '/tickets/EmailTemplates/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ emailTemplatesDetail,
						isNav: false,
						allowedRole: [],
						name: 'emailTemplatesDetail',
						label: 'Email Templates Detail',
					},
					{
						path: '/tickets/EmailTemplates/create',
						exact: true,
						component: emailTemplatesCreate,
						isNav: false,
						allowedRole: [],
						name: 'emailTemplatesCreate',
					},
					{
						path: '/tickets/EmailSignature/general',
						icon: 'fa fa-user-plus',
						exact: true,
						component: /* subdomain ? lPage :*/ emailSignatureList,
						isNav: true,
						allowedRole: [],
						name: 'emailSignature',
						label: 'Email Signature',
					},
					{
						path: '/tickets/EmailSignature/general/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ emailSignatureDetail,
						isNav: false,
						allowedRole: [],
						name: 'emailSignatureDetail',
						label: 'Email Signature Detail',
					},
					{
						path: '/tickets/EmailSetting',
						icon: 'fa fa-user-plus',
						exact: true,
						component: /* subdomain ? lPage :*/ emailSettingList,
						isNav: true,
						allowedRole: [],
						name: 'emailSettings',
						label: 'Email Settings',
					},
					{
						path: '/tickets/EmailSetting/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ emailSettingsDetail,
						isNav: false,
						allowedRole: [],
						name: 'emailSettingsDetail',
						label: 'Email Settings Detail',
					},
					// {
					// 	path: '/tickets/EmailSetting',
					// 	icon: 'fa fa-user-plus',
					// 	exact: true,
					// 	component: /* subdomain ? lPage :*/ emailSettingList,
					// 	isNav: true,
					// 	allowedRole: ['ASC Admin'],
					// 	name: 'emailSettings',
					// 	label: 'Email Settings',
					// },
					{
						path: '/tickets/EmailSetting/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ emailSettingsDetail,
						isNav: false,
						allowedRole: [],
						name: 'emailSettingsDetail',
						label: 'Email Settings Detail',
					},
					{
						path: '/tickets/CustomerSurvey/defaultSetting',
						icon: 'fa fa-user-plus',
						exact: true,
						component: /* subdomain ? lPage :*/ customerSurveyList,
						isNav: true,
						allowedRole: [],
						name: 'customerSurvey',
						label: 'Customer Survey',
					},
					{
						path: '/tickets/CustomerSurvey/defaultSetting/update/:itemId',
						exact: true,
						component: /* subdomain ? lPage :*/ customerSurveyDetail,
						isNav: false,
						allowedRole: [],
						name: 'customerSurveyDetail',
						label: 'Customer Survey Detail',
					},
					{
						path: '/tickets/sla',
						exact: true,
						component: SlaListComponent,
						isNav: true,
						name: 'sla',
						label: 'SLA Goals',
						icon: 'fa fa-calendar',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/sla/create',
						exact: true,
						component: SlaCreateComponent,
						isNav: false,
						name: 'slaCreate',
						label: 'SLA Goals',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/sla/update/:itemId',
						exact: true,
						component: SlaDetailComponent,
						isNav: false,
						name: 'slaUpdate',
						label: 'SLA Goals',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/ProcessFlows',
						exact: true,
						component: ProcessFlowListSearchComponent,
						isNav: true,
						name: 'ProcessFlows',
						label: 'Process Flows',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/ProcessFlow/OverriddenStates/:id',
						exact: true,
						component: OverriddenStateListSearchComponent,
						isNav: false,
						name: 'ProcessFlow',
						label: 'Process Flow',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/ResponseSla',
						exact: true,
						component: ResponseSlaListComponent,
						isNav: true,
						name: 'sla',
						label: 'Response SLA',
						icon: 'fa fa-calendar',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/ResponseSla/create',
						exact: true,
						component: ResponseSlaCreateComponent,
						isNav: false,
						name: 'slaCreate',
						label: 'SLA Goals',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/ResponseSla/update/:itemId',
						exact: true,
						component: ResponseSlaDetailComponent,
						isNav: false,
						name: 'slaUpdate',
						label: 'SLA Goals',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/StatusConfiguration/create/:id',
						exact: true,
						component: StatusConfigurationCreateComponent,
						name: 'StatusConfigurationCreate',
						label: 'Status Configuration Create',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{
						path: '/tickets/StatusConfiguration/update/:id',
						exact: true,
						component: StatusConfigurationCreateComponent,
						name: 'StatusConfigurationUpdate',
						label: 'Status Configuration Update',
						icon: 'fa fa-users',
						allowedRole: ['ticket_admin'],
					},
					{ path: '/tickets/Approved/:caseRefId', exact: false, component: approveByEmail, isNav: false, allowedRole: ['approver', 'ticket_user'] },
					{ path: '/tickets/Rejected/:caseRefId', exact: false, component: approveByEmail, isNav: false, allowedRole: ['approver', 'ticket_user'] },
					{ path: '/tickets/Approved-Level1/:caseRefId', exact: false, component: approveByEmail, isNav: false, allowedRole: ['approver', 'ticket_user'] },
				],
			},

			{
				path: '/tickets/:baseResource/auditLogList',
				icon: 'fa fa-tags',
				exact: true,
				component: /* subdomain ? lPage :*/ AuditLogList,
				isNav: false,
				allowedRole: ['ASC Admin'],
				name: 'auditLog',
				label: 'AduitLog',
			},
			{
				path: '/tickets/:baseResource/auditLogList/update/:itemId',
				icon: 'fa fa-tags',
				exact: true,
				component: /* subdomain ? lPage :*/ AuditLogDetail,
				isNav: false,
				allowedRole: ['ASC Admin'],
				name: 'auditLogDetail',
				label: 'Aduit Log Detail',
			},
			{
				path: '/tickets/Support',
				icon: 'fa fa-tags',
				exact: true,
				component: /* subdomain ? lPage :*/ SupportTicketListing,
				isNav: false,
				allowedRole: ['support_supervisor', 'support_user'],
				name: 'supportTickets',
				label: 'My Support Tickets',
			},

			{
				path: '/tickets/Support/createTicket',
				exact: true,
				component: SupportTicket,
				isNav: false,
				name: 'supportTicket',
				label: 'Support Ticket',
				icon: 'fa fa-support',
				allowedRole: ['support_supervisor', 'support_user'],
			},
			{
				path: '/tickets/Support/ticket-detail/:caseRefId',
				exact: true,
				component: DetailSupportTicket,
				isNav: false,
				name: 'supportTicketDetail',
				label: 'Support Ticket Detail',
				icon: 'fa fa-support',
				allowedRole: ['support_supervisor', 'support_user'],
			},
		],
	},
	{
		path: '/livechat',
		exact: true,
		app: { path: 'livechat' },
		isNav: false,
		name: 'liveChat',
		label: 'Live Chat',
		className:'live-chat',
		icon: <TfiComments/>,
		allowedRole: ['chat_agent', 'chat_agent_admin', 'chat_agent_supervisor'],
	},
	{
		path: '/learning',
		exact: true,
		app: { path: 'learning' },
		isNav: true,
		name: 'learningApp',
		label: 'Learning Mgmt',
		icon: 'fa fa-black-tie',
		allowedRole: ['trainee', 'content_author', 'coach', 'expert'],
	},
	{
		path: '/user-management',
		exact: true,
		app: { path: '/' },
		label: 'Admin App',
		name: 'admin',
		icon: <BsSliders/>,
		isNav: true,
		allowedRole: ['user_admin', 'tenant_admin'],
	},
	{
		path: '/virtualagent',
		exact: true,
		app: { path: 'virtualagent' },
		isNav: true,
		name: 'virtualAgent',
		label: 'Virtual Agent',
		icon: <MdOutlineSupportAgent/>,
		allowedRole: ['bot_user'],
	},
	{
		path: '/profile',
		exact: true,
		component: ProfileContainer,
		isNav: false,
		allowedRole: [
			'billing_analyst',
			'bot_admin',
			'bot_analyst',
			'bot_manager',
			'bot_user',
			'bot bpm_admin',
			'bpm_analyst',
			'chat_agent',
			'chat_agent_admin',
			'chat_agent_supervisor',
			'tenant_admin',
			'ticket_admin',
			'ticket_agent',
			'ticket_agent_supervisor',
			'ticket_user',
			'user_admin',
		],
	},
	{ component: ErrorPage, isNav: false },
]
export const routeListCustom = [
	{ path: '/tickets/agent/dashboard', exact: true, component: TicketingDashboard, isNav: false, name: 'Dashboard1', allowedRole: ['ticket_agent_supervisor'] },
]

export const routeChildren = routesValues => {
	let filterChildren = routesValues.filter(route => route.allowedRole && route.children)
	let childRoutes = []
	filterChildren &&
		filterChildren.forEach((route, index) => {
			//  debugger;;
			let childs =
				route.children &&
				route.children
					.filter(route => route.allowedRole)
					.map(route => {
						let nextChilds =
							route.children && route.children.filter(route => route.allowedRole).map(route => <PrivateRoute key={route.path || 'error'} {...route} />)
						childRoutes.push(nextChilds)
						return <PrivateRoute key={route.path || 'error'} {...route} />
					})

			childRoutes.push(childs)
		})
	return childRoutes
}
export const RootRouter = () => {
	
	const [routesListRender, setRoutesList] = useState(routeList)
	
	useEffect(() => {
		const intervalId = setInterval(() => {
			const tenant = localStorage.getItem('tenant');
			if (tenant && tenant !== "undefined" && typeof tenant === 'string') {
				const tenantData = JSON.parse(tenant || '{}')
				if (tenantData?.custom?.aibot) setRoutesList(routeList.map(r => {
					if (r.name === 'virtualAgent') {
						return {
							...r,
							path: '/virtualagent/aibot',
							app: {
								...r.app,
								path: 'virtualagent/aibot'
							}
						}
					} else {
						return r
					}
				}))
			}
			clearInterval(intervalId);
		}, 1000);
		return () => clearInterval(intervalId);
	}, []);

	return (
		<BrowserRouter history={history}>
			<Switch>
				{routesListRender
					.filter(route => route.allowedRole)
					.map(route => (
						<PrivateRoute key={route.path || 'error'} {...route} />
					))}
				{routeChildren(routesListRender)}
				{routeListCustom
					.filter(route => route.allowedRole)
					.map(route => (
						<PrivateRouteCustom key={route.path || 'error'} {...route} />
					))}
				{routeChildren(routeListCustom)}
				{routesListRender
					.filter(route => !route.allowedRole)
					.map(route => (
						<Route key={route.path || 'error'} {...route} />
					))}
				<Route key="Home" Component={Home} isNav={false} />
			</Switch>
		</BrowserRouter>
	)
}
export const localeLoader = (routePath, tenantId) => {
	let val = sessionStorage.getItem('basePathName')
	let currentVal = routePath && routePath.includes('tickets') ? 'tickets' : 'approvals'
	if (currentVal != val) {
		// console.log(appRootPathPrefix().slice(1), 'Routes')
		reloadResources(tenantId)
	}
	sessionStorage.setItem('basePathName', currentVal)
}
